import { V2MicrogridOverviewIncomeAnalysePostResponse } from '@maxtropy/intelligent-dispath-apis-v2';
import dayjs from 'dayjs';

import * as echarts from 'echarts';
import { keepTwoNull } from '../utils';
import { ResolutionEnum } from '../type';

const areaColors = [
  new echarts.graphic.LinearGradient(0, 0, 0, 1, [
    { offset: 0, color: 'rgba(82, 231, 255,0.2)' },
    { offset: 1, color: 'rgba(82, 231, 255,0.1)' },
  ]),
  new echarts.graphic.LinearGradient(0, 0, 0, 1, [
    { offset: 0, color: 'rgba(250, 204, 88, 0.2)' },
    { offset: 1, color: 'rgba(250, 204, 88, 0.1)' },
  ]),
];

export const getChartOption = (
  resolution: ResolutionEnum,
  chartData?: V2MicrogridOverviewIncomeAnalysePostResponse
) => {
  const formatDate = resolution === ResolutionEnum.DAY ? 'HH:mm' : 'MM-DD';

  let actualData = (chartData?.list ?? []).map(item => [
    dayjs(item.time).valueOf(),
    keepTwoNull(item.nonAlgorithmIncome),
  ]);

  let predictData = (chartData?.list ?? []).map(item => [
    dayjs(item.time).valueOf(),
    keepTwoNull(item.algorithmIncome),
  ]);

  const commonOption = {
    tooltip: {
      formatter: (items: any) => {
        let { axisValue } = items[0];
        let firstStr = dayjs(axisValue).format(formatDate);
        let otherStr = '';
        let str = '';

        items.forEach((item: any) => {
          const { seriesName, data } = item;
          let unit = '元';
          otherStr += `<div style="margin-top:8px"><span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:${
            item.color
          };"></span>${seriesName} : &nbsp;${data[1] || data[1] === 0 ? data[1] + unit : '-'}</div>`;
          str = firstStr + otherStr;
        });

        return str;
      },
    },
    grid: {
      left: 20,
      right: 20,
      top: 60,
      bottom: 40,
      containLabel: true,
    },
    dataZoom: [
      {
        type: 'slider',
        bottom: 10,
        left: 25,
        right: 20,
        height: 20,
        textStyle: {
          fontSize: 10,
        },
        labelFormatter: (value: string) => {
          return dayjs(value).format(formatDate);
        },
      },
    ],
    xAxis: [
      {
        type: 'time',
        axisLabel: {
          formatter: function (e: number) {
            return dayjs(e, 'x').format(formatDate);
          },
        },
        axisPointer: {
          type: 'shadow',
        },
      },
    ],
    yAxis: [
      {
        type: 'value',
        name: '元',
        axisLabel: {
          formatter: '{value}',
        },
      },
    ],
  };
  if (resolution === ResolutionEnum.DAY) {
    return {
      ...commonOption,
      color: ['#52E7FF', '#FACC58'],
      legend: {
        right: 10,
        itemWidth: 16,
        itemHeight: 4,
        data: [
          {
            name: '非算法调度',
            icon: 'rect',
          },
          {
            name: '算法调度',
            icon: 'path://M54 468h261v90H54zM378 468h261v90H378zM702 468h261v90H702z',
          },
        ],
      },

      series: [
        {
          name: '非算法调度',
          type: 'line',
          data: actualData,
          barWidth: 5,
          connectNulls: true,
          smooth: true,
          symbol: 'circle',
          symbolSize: 6,
          itemStyle: {
            // symbol样式
            normal: {
              borderColor: 'rgba(255, 255, 255, 0.2)', // symbol边框颜色
              borderWidth: 2, // symbol边框宽度
            },
          },
          lineStyle: {
            width: 2,
            type: 'solid', //'dotted'点型虚线 'solid'实线 'dashed'线性虚线
          },
          areaStyle: {
            color: areaColors[0],
          },
        },
        {
          name: '算法调度',
          type: 'line',
          data: predictData,
          barWidth: 5,
          connectNulls: true,
          smooth: true,
          symbol: 'circle',
          symbolSize: 6,
          itemStyle: {
            // symbol样式
            normal: {
              borderColor: 'rgba(255, 255, 255, 0.2)', // symbol边框颜色
              borderWidth: 2, // symbol边框宽度
            },
          },
          lineStyle: {
            width: 4,
            type: 'dotted', //'dotted'点型虚线 'solid'实线 'dashed'线性虚线
          },
          areaStyle: {
            color: areaColors[1],
          },
        },
      ],
    };
  }

  return {
    ...commonOption,
    color: ['#FFCB47', '#00ADFF'],
    legend: {
      right: 10,
      itemWidth: 12,
      itemHeight: 8,
      data: [
        {
          name: '非算法调度',
          icon: 'rect',
        },
        {
          name: '算法调度',
          icon: 'rect',
        },
      ],
    },

    series: [
      {
        name: '非算法调度',
        type: 'bar',
        data: actualData,
        barWidth: 5,
      },
      {
        name: '算法调度',
        type: 'bar',
        data: predictData,
        barWidth: 5,
      },
    ],
  };
};
